var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M7.57067 20.071L5.42967 17.93C4.91667 17.417 4.91667 16.584 5.42967 16.071C6.12767 15.373 6.60367 14.484 6.79667 13.516L7.49967 10L15.4997 18L11.9837 18.703C11.0157 18.897 10.1267 19.372 9.42867 20.07C8.91567 20.584 8.08367 20.584 7.57067 20.071Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3L7.5 10L15.5 18L21.5 12V3H15.5Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42991 17.9301C5.27191 17.7721 5.17991 17.5811 5.11891 17.3821L3.99991 18.5001C3.17191 19.3281 3.17191 20.6721 3.99991 21.5001C4.82791 22.3281 6.17191 22.3281 6.99991 21.5001L8.11891 20.3811C7.91991 20.3201 7.72891 20.2281 7.57091 20.0701L5.42991 17.9301Z",
    fill: "black",
    fillOpacity: 0.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteboard);
export default __webpack_public_path__ + "static/media/whiteboard.13738b6f9a3382e07c3e442223e7559f.svg";
export { ForwardRef as ReactComponent };